import React from "react";
import styled from "@emotion/styled";
import {
  getMerchantArray,
  getCategoryMerchantArray
} from "@modules/Buy/selector";
import { useSelector } from "react-redux";

const Container = styled.p`
  margin: 0;
`;

const BuyPageBrands = () => {
  const getMerchantArraySelector = useSelector(state =>
    !state.userActions.selectedCategory
      ? getMerchantArray({
          merchantArray: state.merchantsBuy.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards
        })
      : getCategoryMerchantArray({
          merchantArray: state.merchantsBuy.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards,
          categories: state.categories.allCategories,
          categoryName: state.userActions.selectedCategory
        })
  );
  return (
    <Container>
      {getMerchantArraySelector && (
        <>{getMerchantArraySelector.length} brands found</>
      )}
    </Container>
  );
};

export default BuyPageBrands;
